import { DataTable } from '../DataTable/DataTable'
import { buildTenantsTableColumns } from './helpers/buildTenantsTableColumns'
import type { TenantsTableProps } from './TenantsTable.types'

export function TenantsTable({
  tenants,
  tenantGroups,
  onRowClick,
}: TenantsTableProps) {
  return (
    <DataTable
      columns={buildTenantsTableColumns(tenantGroups)}
      data={tenants}
      rowKey={(t) => t.id}
      emptyMessage="No tenants found."
      onRowClick={onRowClick}
    />
  )
}
